const addWidgetListeners = function(prevWidget, widget) {
	prevWidget.addEventListener('click', () => {
		if(!prevWidget.classList.contains('woo-widget-dropdown-trigger')) {
			return;
		}
		if(prevWidget.classList.contains('open')) {
			prevWidget.classList.remove('open');
			widget.style.display = '';

			return;
		}
		prevWidget.classList.add('open');
		widget.style.display = 'block';
	});
}

const prepareDropdown = function(widget) {
	const parentEl = widget.parentElement;
	const prevWidget = parentEl.previousElementSibling;
	const prevWidgetElements = prevWidget.querySelectorAll('*');
	const allowedTags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P'];

	if(prevWidgetElements.length === 1 && allowedTags.includes(prevWidgetElements[0].tagName)) {
		let mq = window.matchMedia('(max-width: 991px)');

		if(mq.matches) {
			prevWidget.classList.add('woo-widget-dropdown-trigger');
			parentEl.classList.add('woo-widget-dropdown-content');
		}

		addWidgetListeners(prevWidget, widget);

		window.addEventListener('resize', () => {
			if(!mq.matches) {
				prevWidget.classList.remove('woo-widget-dropdown-trigger');
				parentEl.classList.remove('woo-widget-dropdown-content');
				prevWidget.classList.remove('open');
				widget.style.display = '';

				return;
			}

			prevWidget.classList.add('woo-widget-dropdown-trigger');
			parentEl.classList.add('woo-widget-dropdown-content');
		});
	}
}

const categoriesDropdownInit = function() {
	const categoriesWidgets = document.querySelectorAll('.woocommerce .wc-block-product-categories.is-list');

	for (let i = 0; i < categoriesWidgets.length; i++) {
		const element = categoriesWidgets[i];

		prepareDropdown(element);
	}
}

export default categoriesDropdownInit;